import {
  InvoiceDeliveryStatusEnum,
  InvoicePaymentStatusEnum,
  InvoiceStateEnum,
  InvoiceStatusEnum
} from '../../common/enums/invoicing.enum';
import { InvoiceDto } from '../../common/interfaces/invoicing.interface';

/**
 * The one state of an invoice, by the server's rule (`invoiceStateOf` in the API): payment
 * before delivery. The list uses the server's `state`; this is the fallback for a response
 * that does not carry it, so a row never renders without a state.
 */
export const invoiceStateOf = (invoice: Pick<InvoiceDto, 'status' | 'paymentStatus' | 'deliveryStatus' | 'state'>): InvoiceStateEnum => {
  if (invoice.state && Object.values(InvoiceStateEnum).includes(invoice.state)) return invoice.state;
  if (invoice.status === InvoiceStatusEnum.CANCELLED) return InvoiceStateEnum.CANCELLED;
  if (invoice.status === InvoiceStatusEnum.DRAFT) return InvoiceStateEnum.DRAFT;
  if (invoice.paymentStatus === InvoicePaymentStatusEnum.PAID) return InvoiceStateEnum.PAID;
  if (invoice.paymentStatus === InvoicePaymentStatusEnum.PARTIALLY_PAID) return InvoiceStateEnum.PARTIALLY_PAID;
  if (invoice.deliveryStatus === InvoiceDeliveryStatusEnum.FAILED) return InvoiceStateEnum.SEND_FAILED;
  if (invoice.deliveryStatus === InvoiceDeliveryStatusEnum.SENT || invoice.deliveryStatus === InvoiceDeliveryStatusEnum.QUEUED) {
    return InvoiceStateEnum.SENT;
  }
  return InvoiceStateEnum.ISSUED_NOT_SENT;
};
